var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 20,
    viewBox: "0 0 5 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 20C1.8125 20 1.22396 19.7552 0.734375 19.2656C0.244792 18.776 0 18.1875 0 17.5C0 16.8125 0.244792 16.224 0.734375 15.7344C1.22396 15.2448 1.8125 15 2.5 15C3.1875 15 3.77604 15.2448 4.26562 15.7344C4.75521 16.224 5 16.8125 5 17.5C5 18.1875 4.75521 18.776 4.26562 19.2656C3.77604 19.7552 3.1875 20 2.5 20ZM2.5 12.5C1.8125 12.5 1.22396 12.2552 0.734375 11.7656C0.244792 11.276 0 10.6875 0 10C0 9.3125 0.244792 8.72396 0.734375 8.23438C1.22396 7.74479 1.8125 7.5 2.5 7.5C3.1875 7.5 3.77604 7.74479 4.26562 8.23438C4.75521 8.72396 5 9.3125 5 10C5 10.6875 4.75521 11.276 4.26562 11.7656C3.77604 12.2552 3.1875 12.5 2.5 12.5ZM2.5 5C1.8125 5 1.22396 4.75521 0.734375 4.26562C0.244792 3.77604 0 3.1875 0 2.5C0 1.8125 0.244792 1.22396 0.734375 0.734375C1.22396 0.244792 1.8125 0 2.5 0C3.1875 0 3.77604 0.244792 4.26562 0.734375C4.75521 1.22396 5 1.8125 5 2.5C5 3.1875 4.75521 3.77604 4.26562 4.26562C3.77604 4.75521 3.1875 5 2.5 5Z",
    fill: "#6C6C6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector4);
export default __webpack_public_path__ + "static/media/Vector (4).1b2ed4fcb455372775477aa48bd778cb.svg";
export { ForwardRef as ReactComponent };